import { Link } from 'wouter-preact'

import { Button, HorizontalDivider, Typography } from 'components'

const TeamsPage = () => (
	<div class='flex-1'>
		<Typography color='text-black-100' text='Teams' variant='h3' />
		<Typography
			class='mt-5'
			color='text-black-200'
			text="Unlock management tools, providing enhanced coordination, access control, and productivity features tailored to support your Organization's needs."
			variant='text1'
		/>

		<HorizontalDivider className='my-10' />

		<Typography color='text-black-100' text='Your Teams' variant='h4' />
		<Typography
			class='mt-5'
			color='text-black-200'
			text='You have nothing created yet.'
			variant='text1'
		/>

		<Link href='/setup-team'>
			<Button className='mt-10' text='Create Team' />
		</Link>
	</div>
)

export { TeamsPage }
